<app-layout title="Revisión de Informes">
  <!-- Área de Filtros -->
  <div class="mb-3 row align-items-center px-3">
    <div class="col-md-1">
      <label for="" class="form-label form-label-sm">Registros</label>
      <select id="" class="form-select form-select-sm" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
        <option *ngFor="let size of [5, 10, 20, 50]" [value]="size">{{ size }}</option>
      </select>
    </div>
    <div class="col-md-2">
      <label for="filterUser" class="form-label form-label-sm">Usuario</label>
      <input type="text" name="" id="" class="form-control form-control-sm" placeholder="Nombre de Usuario"
        [(ngModel)]="username">
    </div>
    <div class="col-md-2">
      <label for="filterPeriod" class="form-label form-label-sm">Periodo</label>
      <select id="filterPeriod" class="form-select form-select-sm" [(ngModel)]="periodId">
        <option value="">Seleccione un periodo</option>
        <option *ngFor="let p of periods" [value]="p._id">{{p.name}}</option>
      </select>
    </div>
    <div class="col-md-2">
      <label for="" class="form-label form-label-sm">Licencia</label>
      <select id="" class="form-select form-select-sm" [(ngModel)]="licenseId">
        <option value="">Seleccione Licencia</option>
        <option *ngFor="let l of missionarylicenses" [value]="l._id">{{l.name}}</option>
      </select>
    </div>
    <div class="col-md-2">
      <label for="" class="form-label form-label-sm">Estado (Pendiente)</label>
      <select id="" class="form-select form-select-sm" [(ngModel)]="stateId">
        <option value="">Seleccione Estado</option>
        <option *ngFor="let r of reportstates" [value]="r._id">{{r.name}}</option>
      </select>
    </div>

    <div class="col-md-1 mt-2">
      <p class="text-dark fw-bold">{{ totalRecords }} informes
      </p>
    </div>

    <div class="col-md-1 mt-4">
      <!-- un botón estilo dropdown que me de las opciones Resumen Dependientes y Resumen Independientes -->
      <div class="dropdown">
        <button class="btn btn-secondary btn-sm dropdown-toggle w-100" type="button" id="dropdownMenuButton1"
          data-bs-toggle="dropdown" aria-expanded="false">
          Resumen
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li><a class="dropdown-item" (click)="generateResumeIndependents()">Resumen Independientes</a></li>
          <li><a class="dropdown-item" (click)="generateResumeDependents()">Resumen Dependientes</a></li>
        </ul>
      </div>

    </div>

    <div class="col-md-1 mt-4">
      <button class="btn btn-primary btn-sm w-100" (click)="onSearch()">Buscar</button>
    </div>

  </div>
  <!-- Tabla -->
 
    <div class="table-responsive p-3">
      <table class="table table-hover table-sm align-middle border border-secondary rounded-4 mt-4">
        <thead class="table-primary text-center">
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th>Rut</th>
            <th>Valor Informe</th>
            <th>Periodo</th>
            <th>Fecha de Envio</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of reports" class="text-center form-label-sm">
            <td>{{ r.user.employee_code }}</td>
            <td>{{ r.user.name }}</td>
            <td>{{ r.user.rut}}</td>
            <td>${{ r.value | number: '1.0-0':'es-ES'}}</td>
            <td>{{r.period.name}}</td>
            <td> {{ r.createdAt | date: 'dd-MM-yyyy'}}</td>
            <td>
              <span class="badge" *ngIf="r.state?.name" [ngClass]="{
            'bg-success': r.state.name === 'Aprobado',
            'bg-info text-dark': r.state.name === 'En revisión',
            'bg-danger': r.state.name === 'Rechazado',
            'bg-warning text-dark':r.state.name === 'En Corrección',
            'bg-primary': ['Aprobado', 'En revisión', 'Rechazado', 'En Corrección'].indexOf(r.state.name) === -1}">
                {{ r.state.name }}
              </span>
            </td>
            <td>
              <button class="btn btn-warning btn-sm me-1" title="Editar" (click)="onEdit(r._id, true)">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button class="btn btn-danger btn-sm" title="Eliminar">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  <!--Controles de paginación -->
  <div class="d-flex justify-content-center mt-3">
    <!-- Paginador Manual -->
    <nav>
      <ul class="pagination justify-content-center mt-3">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" (click)="changePage(currentPage - 1)">Anterior</a>
        </li>

        <li *ngFor="let page of getPaginationArray()" class="page-item" [class.active]="currentPage === page">
          <a class="page-link" (click)="changePage(page)">{{ page }}</a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" (click)="changePage(currentPage + 1)">Siguiente</a>
        </li>
      </ul>
    </nav>
  </div>
</app-layout>